<div *ngIf="culturalActivityTypeMetadata as typeMetadata"
     class="activity-card card"
     [class.is-completed]="activity.isCompleted"
     [class.is-overdue]="isOverdue && highlightOverdue"
     [class.is-upcoming]="!isOverdue"
     [style.--activity-accent]="typeMetadata.colourAccent">
    <div class="card-body d-flex flex-column gap-3">
        <div class="d-flex flex-row gap-2 align-items-center">
            <h4 class="m-0 flex-grow-1">
                <ng-container *ngIf="activity.type === CulturalActivityType.CareerValuation || activity.type === CulturalActivityType.CulturalIndex">
                    <ng-container *ngIf="currentPersonIsCulturalLeaderForActivity; else normalUser">
                        {{typeMetadata.shortTitle}} for
                    </ng-container>
                    <ng-template #normalUser>
                        {{isCulturalLeader ? 'My ' : ''}}{{typeMetadata.shortTitle}} with
                    </ng-template>
                    <adapt-link-person [personId]="otherPersonId ?? activity.person1Id"></adapt-link-person>
                </ng-container>
                <ng-container *ngIf="activity.type === CulturalActivityType.PeerCatchUp">
                    <ng-container *ngIf="activity.team; else noTeamNavProp">
                        <a [routerLink]="routeLink?.path"
                           [queryParams]="routeLink?.queryParams">{{activity.team.name}}</a>:
                    </ng-container>
                    {{typeMetadata.shortTitle}} with
                    <adapt-link-person [personId]="otherPersonId ?? activity.person1Id"></adapt-link-person>
                </ng-container>
                <ng-container *ngIf="activity.type === CulturalActivityType.ResilientBusinessAssessment">{{survey?.name ?? "Assessment to be scheduled"}}</ng-container>
                <ng-container *ngIf="activity.type === CulturalActivityType.EmployeeEngagementAssessment">{{survey?.name ?? "Assessment to be scheduled"}}</ng-container>
                <ng-container *ngIf="activity.type === CulturalActivityType.TeamAssessment">
                    <ng-container *ngIf="activity.team; else noTeamNavProp">
                        <a [routerLink]="routeLink?.path"
                           [queryParams]="routeLink?.queryParams">{{activity.team.name}}</a>:
                    </ng-container>
                    {{survey?.name ?? "Assessment to be scheduled"}}
                </ng-container>

                <ng-template #noTeamNavProp>
                    <ng-container *ngIf="activity.teamId">
                        <adapt-link-team *ngIf="activity.teamId"
                                         [teamId]="activity.teamId"></adapt-link-team>:
                    </ng-container>
                </ng-template>
            </h4>

            <i *ngIf="(activity.type === CulturalActivityType.CareerValuation || activity.type === CulturalActivityType.CulturalIndex)
                    && currentPersonIsCulturalLeaderForActivity && culturalLeadershipConfiguration"
               adaptTooltip="This {{typeMetadata.shortTitle.toLocaleLowerCase()}} is as their {{culturalLeadershipConfiguration.primaryName.toLocaleLowerCase()}}"
               class="fal fa-chart-user"></i>

            <adapt-menu *ngIf="menuItems && allowActions"
                        [items]="menuItems"></adapt-menu>
        </div>

        <div class="d-flex flex-row gap-3 justify-content-between align-items-center">
            <div>
                <!-- unsubscribeOnDestroy in case entitySync for culturalActivity causes the card to be destroyed -->
                <button *ngIf="canReschedule && allowActions"
                        class="btn btn-link"
                        [adaptBlockingClick]="rescheduleActivity"
                        [unsubscribeOnDestroy]="false"
                        data-test="reschedule-activity-button">Reschedule</button>

                <div class="text-muted">{{dueText}}: {{dueDate | adaptDate}}
                    <adapt-activity-rescheduled-info *ngIf="hasRescheduled && !activity.isCompleted"
                                                     [activity]="activity"
                                                     [showOriginalDate]="!isStartedSurvey"></adapt-activity-rescheduled-info>
                </div>
            </div>

            <div>
                <button *ngIf="canStartActivity && allowActions"
                        class="btn btn-sm btn-primary"
                        [adaptButtonIcon]="startActivityIconClass"
                        [adaptBlockingClick]="startActivity"
                        [unsubscribeOnDestroy]="false"
                        data-test="activity-start-button">{{startActivityText}}</button>
            </div>
        </div>
    </div>
</div>
